///<reference path='dashboardAddOption.controller.ts'/>

namespace Dashboard {

    class AddBaggage extends AddOption {
        private buttonLabel : string;

        constructor(
            protected $location: ng.ILocationService,
            protected $q: ng.IQService,
            protected $routeParams,
            protected $scope: ng.IScope,
            protected $window: ng.IWindowService,
            protected broker: Core.Broker,
            protected customCurrencyFilter,
            protected dashboardBookingService,
            protected flightExtrasService,
            protected mybTrack,
            protected paymentDetailsService,
            protected paymentsService,
            protected paymentsUtilService: Core.PaymentsUtilService,
            protected resourceService: Core.ResourceService,
            protected rootPath: Core.RootPath,
            protected urlUtils,
            protected dateUtil,
            protected currentUser
        ) {

            super($location,
                  $q,
                  $routeParams,
                  $scope,
                  $window,
                  broker,
                  customCurrencyFilter,
                  dashboardBookingService,
                  flightExtrasService,
                  mybTrack,
                  paymentDetailsService,
                  paymentsService,
                  paymentsUtilService,
                  resourceService,
                  rootPath,
                  urlUtils,
                  dateUtil,
                  currentUser);
            this.$scope.$watch('cm.selectedOptions', () => this.updateButtonLabel());
            this.$scope.$watch('cm.paymentModel.fee', () => this.updateButtonLabel());
        }

        private updateButtonLabel(): void {
            this.buttonLabel = this.getButtonLabel();
        }

        private getButtonLabel() : string {
            if (this.selectedOptions && this.selectedOptions.length === 1) {
                return String.format(this.resourceService.get('PAYFORONEBAG'),
                    this.customCurrencyFilter(this.selectedOptionsTotalPrice + this.paymentModel.fee));
            }
            if (this.selectedOptions && this.selectedOptions.length > 1) {
                return String.format(this.resourceService.get('PAYFORBAGS'),
                    this.customCurrencyFilter(this.selectedOptionsTotalPrice + this.paymentModel.fee),
                    this.selectedOptions.length);
            }
            return this.resourceService.get('ADDBAGSTOPAY');
        }

        protected analyticsTrackOpenOption() : void {
            this.mybTrack.track('MYB - Add Bag Payment', {
                NumberOfHoldBags: this.selectedOptions.length || 0,
                NumberOfHandBags: this.handBaggageInformation &&
                    this.handBaggageInformation.PiecesAllowed,
                        PaymentMethod: this.paymentMethodText[this.paymentTab] || '',
                        Source: this.$routeParams.source === 'noneml' ? 'email' : 'cross-Sell',
                        SuplierIds: this.supplierIds
                });
        }

        protected getConfig() : AddOptionConfig {
            return {
                completeUrl: 'dashboard/add-baggage/complete/{0}',
                optionsType: 'BagOptions',
                availableOptionsBinding: 'bagOptions',
                selectedOptionsBinding: 'selectedOptions',
                selectedOptionsRequest: 'SelectedOptions',
                analyticsTag: 'MYB - Open Add Bag',
                pageUrl: 'dashboard/add-baggage'
            };
        }

        protected canAddOption(optionsData) : boolean {
            return !!(optionsData && optionsData.CanAddBags);
        }
    }

    angular
        .module('dashboard')
        .controller('AddBaggage', AddBaggage);

}
